import BaseService from "./BaseService";

export default class ProuniService extends BaseService {

    constructor(self) {
        super(self);
    }

    RetornaToken(parameters) {
        return this.ExecutaFetch("/api/Raid/RetornaToken", "POST", parameters);
    }
}